import React, { Component} from 'react';

import Windows from './windows';
import Footer from '../footer/footer';

import './homePage.css';

class Homepage extends Component {
  render() {
    return (
	<div className="Homepage">
		<Windows />
		<Footer />
	</div>
    );
  }
}


export default Homepage;



// WEBPACK FOOTER //
// ./src/components/homepage/homepage.js